import { takeLatest, call, put } from "redux-saga/effects";
import {
  settingsUpdated,
  SETTINGS_UPDATE_REQUEST,
  settingsUpdateError,
} from "../../actions/global-settings";
import updateSettings from "../../../../../backend/oncall/partners/contact-details/update";

const requestUpdate = function*(action) {
  try {
    yield call(
      updateSettings,
      action.payload.formData.adminContactName,
      action.payload.formData.adminContactEmail,
    );
    yield put(settingsUpdated());
  } catch (error) {
    yield put(settingsUpdateError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(SETTINGS_UPDATE_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/global-settings/request-update.js